import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getShipment = data => {
  return axios.request({
    url: "/finance/orderfinance",
    method: "post",
    data
  });
};

// 重新计算运费
export const refShipments = data => {
  return axios.request({
    url: "/finance/bill/handleFinance",
    method: "post",
    data
  });
};

export const exportOutBound = data => {
  return axios.request({
    url: "/finance/orderfinance/exportOutBound",
    method: "post",
    data
  });
};

export const getTags = () => {
  return axios.request({
    url: "/finance/orderfinance/tags",
    method: "get"
  });
};

export const createBill = data => {
  return axios.request({
    url: "/finance/orderfinance/createBill",
    method: "post",
    data
  });
};

export const cancelHang = data => {
  return axios.request({
    url: "/finance/orderfinance/cancelAbnormal",
    method: "post",
    data
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/finance/orderfinance/updateWeightFinance",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const getConfig = () => {
  return axios.request({
    url: "/finance/OrderFinance/config",
    method: "get"
  });
};

export const setJiYun = data => {
  return axios.request({
    url: "/finance/hq/outbound/setJiYun",
    method: "post",
    data
  });
};

